export default __webpack_public_path__ + "static/media/portfolio-107.7b0710c3.jpg";